/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessagesColumn.vue?vue&type=template&id=5d718311&scoped=true"
import script from "./ChatMessagesColumn.vue?vue&type=script&lang=js"
export * from "./ChatMessagesColumn.vue?vue&type=script&lang=js"
import style0 from "./ChatMessagesColumn.vue?vue&type=style&index=0&id=5d718311&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d718311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d718311')) {
      api.createRecord('5d718311', component.options)
    } else {
      api.reload('5d718311', component.options)
    }
    module.hot.accept("./ChatMessagesColumn.vue?vue&type=template&id=5d718311&scoped=true", function () {
      api.rerender('5d718311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatMessagesColumn.vue"
export default component.exports